import PropTypes from 'prop-types';
import './loader.scss';

const Loader = ({ color, customClass, loadingText }) => {
    return (
        <div className={`loader-wrapper ${customClass || 'widget-loader'}`}>
            <div className="lds-ellipsis">
                <div style={{ backgroundColor: color }} />
                <div style={{ backgroundColor: color }} />
                <div style={{ backgroundColor: color }} />
                <div style={{ backgroundColor: color }} />
            </div>
            {loadingText && <div className="loading-text">{loadingText}</div>}
        </div>
    );
};

Loader.propTypes = {
    color: PropTypes.string,
    customClass: PropTypes.string,
    loadingText: PropTypes.string
};

Loader.defaultProps = {
    color: '#29ABE2',
    customClass: '',
    loadingText: ''
};

export default Loader;
